export const companyTypes = [
  {
    id: '1099',
    label: '1099',
  },
  {
    id: 'w2',
    label: 'W2',
  },
] as const

export type CompanyType = (typeof companyTypes)[number]['id']
